export enum ExerciseType {
    Intro = 0,
    Exercise = 1,
    Goal = 2,
    Hidden = 3,
    WitnessStatement = 4,
    Info = 5,
    Feedback = 6,
    SmallMedia = 7,
    Article = 8,
    CheckIn = 9,
}
